module.exports = __webpack_public_path__ + "img/spotted-orange-lily.e1c42fe8.webp";